// extracted by mini-css-extract-plugin
module.exports = {"blackCurtain":"popup_blackCurtain__kqL86","active":"popup_active__3Jld2","popup":"popup_popup__2ySto","popupBlock":"popup_popupBlock__9hQvA","peekingCat":"popup_peekingCat__1I375"};